(() => {
  const selector = '.jdgm-carousel-item__product-image[data-src], img[alt="PROMIROSE founder portrait"]';
  const restore = (image) => {
    if (image.alt === 'PROMIROSE founder portrait') {
      const portrait = 'https://app.omnisend.com/images/650a2abd4f2f82f10c6c2b4e';
      if (image.getAttribute('src') === portrait) return;
      image.removeAttribute('srcset');
      image.src = portrait;
      image.width = 120;
      image.height = 181;
      image.style.height = 'auto';
      image.style.maxWidth = '100%';
      return;
    }
    if (image.getAttribute('src')) return;
    const source = image.getAttribute('data-src-retina') || image.getAttribute('data-src');
    if (!source) return;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.src = source;
  };
  const scan = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector)) restore(root);
    root.querySelectorAll(selector).forEach(restore);
  };
  const initialize = () => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') restore(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-src', 'data-src-retina']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
